import loadExperiencesLogic from "./loadExperiencesLogic";
import loadExperiencesFailLogic from "./loadExperiencesFailLogic";
import createExperienceLogic from "./createExperienceLogic";
import createExperienceSuccessLogic from "./createExperienceSuccessLogic";
import createExperienceFailLogic from "./createExperienceFailLogic";
import editExperienceLogic from "./editExperienceLogic";
import editExperienceSuccessLogic from "./editExperienceSuccessLogic";
import editExperienceFailLogic from "./editExperienceFailLogic";
import deleteExperienceLogic from "./deleteExperienceLogic";
import deleteExperienceSuccessLogic from "./deleteExperienceSuccessLogic";
import deleteExperienceFailLogic from "./deleteExperienceFailLogic";
import loadExperienceNavigationLogic from "./loadExperienceNavigationLogic";
import editExperienceNavigationLogic from "./editExperienceNavigationLogic";

export default [
	...loadExperiencesLogic,
	...loadExperiencesFailLogic,
	...createExperienceLogic,
	...createExperienceSuccessLogic,
	...createExperienceFailLogic,
	...editExperienceLogic,
	...editExperienceSuccessLogic,
	...editExperienceFailLogic,
	...deleteExperienceLogic,
	...deleteExperienceSuccessLogic,
	...deleteExperienceFailLogic,
	...loadExperienceNavigationLogic,
	...editExperienceNavigationLogic,
];
